import { render, staticRenderFns } from "./addClientUser.vue?vue&type=template&id=39132365&scoped=true&"
import script from "./addClientUser.vue?vue&type=script&lang=js&"
export * from "./addClientUser.vue?vue&type=script&lang=js&"
import style0 from "./addClientUser.vue?vue&type=style&index=0&id=39132365&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39132365",
  null
  
)

export default component.exports